import axios from "axios";

const axiosInterceptor = axios.create({
  timeout: 50000000,
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

axiosInterceptor.interceptors.request.use(async (config) => {
  let token = "";

  if (typeof window !== "undefined") {
    token = sessionStorage.getItem("token") ?? "";
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInterceptor.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default axiosInterceptor;
